var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":`orkestro-chat-widget-wrapper-${_vm.deliveryProviderId}-${_vm.location}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }